import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=f597b526&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"
import style0 from "./Forms.vue?vue&type=style&index=0&id=f597b526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f597b526",
  null
  
)

export default component.exports